<template>
<div class="home">


<div class="creppy-white-blass-wait">
  <h5 style="padding-top: 20px" class="display-title-strong middle-wave text-white">Impressum</h5>

  <br class="no-move"/>

  <h5 class="smaller-normal-text middle-wave text-white">Datenschutz<br class="no-move"/>Erklärung</h5>

  <p class="normal-text-secondary container">
    <b-button v-b-modal.modal-xl variant="light"><strong>Hier öffnen</strong></b-button>
  </p>

  <br class="no-move"/>
  <br class="no-move"/>
  <br class="no-move"/>

</div>

<div class="main-title">

  <h1 class="headers-text text-dark"><strong>Kontakt</strong></h1>
  <p class="body-title-lighter text-dark"><strong>Angaben Gemäß §5 TMG </strong></p>
  <br class="no-move"/>

  <div class="container">
    <div class=" white-shadow text-dark">
      <p class="normal-text-secondary text-dark">
        Marvin Hülsmann
        <br class="no-move"/>
        Nelkenstraße 17
        <br class="no-move"/>
        59073 Hamm
        <br class="no-move"/>
        <br class="no-move"/>
        Telefon: auf Anfrage<br class="no-move"/>
        E-Mail: <a href="mailto:imprint@labyhelp.de" class="__cf_email__"
                   data-cfemail="c0a9aea6af80a3afb3ada5b4a9a3b3adafa4eea4a5">imprint[at]labyhelp.de</a>

      </p>

    </div>

    <b-modal size="xl" id="modal-xl" title="Data">
      <h1 class="adsimple-321190275 text-dark">Datenschutzerklärung</h1>
      <h2 class="adsimple-321190275">Datenschutz</h2>
      <p class="text-dark">Wir haben diese Datenschutzerklärung (Fassung 29.06.2021-321190275) verfasst, um
        Ihnen gemäß der Vorgaben der <a class="adsimple-321190275"
                                        href="https://eur-lex.europa.eu/legal-content/DE/ALL/?uri=celex%3A32016R0679&amp;tid=321190275"
                                        target="_blank" rel="noopener">Datenschutz-Grundverordnung (EU)
          2016/679</a> zu erklären, welche Informationen wir sammeln, wie wir Daten verwenden und welche
        Entscheidungsmöglichkeiten Sie als Besucher dieser Webseite haben.</p>
      <p class="text-dark">Leider liegt es in der Natur der Sache, dass diese Erklärungen sehr technisch
        klingen, wir haben uns bei der Erstellung jedoch bemüht die wichtigsten Dinge so einfach und klar
        wie möglich zu beschreiben.</p>
      <h2 class="adsimple-321190275">Automatische Datenspeicherung</h2>
      <p class="text-dark">Wenn Sie heutzutage Webseiten besuchen, werden gewisse Informationen automatisch
        erstellt und gespeichert, so auch auf dieser Webseite.</p>
      <p class="text-dark">Wenn Sie unsere Webseite so wie jetzt gerade besuchen, speichert unser Webserver
        (Computer auf dem diese Webseite gespeichert ist) automatisch Daten wie</p>
      <ul class="adsimple-321190275">
        <li class="adsimple-321190275">die Adresse (URL) der aufgerufenen Webseite</li>
        <li class="adsimple-321190275">Browser und Browserversion</li>
        <li class="adsimple-321190275">das verwendete Betriebssystem</li>
        <li class="adsimple-321190275">die Adresse (URL) der zuvor besuchten Seite (Referrer URL)</li>
        <li class="adsimple-321190275">den Hostname und die IP-Adresse des Geräts von welchem aus
          zugegriffen wird
        </li>
        <li class="adsimple-321190275">Datum und Uhrzeit</li>
      </ul>
      <p class="text-dark">in Dateien (Webserver-Logfiles).</p>
      <p class="text-dark">In der Regel werden Webserver-Logfiles zwei Wochen gespeichert und danach
        automatisch gelöscht. Wir geben diese Daten nicht weiter, können jedoch nicht ausschließen, dass
        diese Daten beim Vorliegen von rechtswidrigem Verhalten eingesehen werden.</p>
      <h2 class="adsimple-321190275">Cookies</h2>
      <p class="text-dark">Unsere Website verwendet HTTP-Cookies um nutzerspezifische Daten zu speichern.<br/>
        Im Folgenden erklären wir, was Cookies sind und warum Sie genutzt werden, damit Sie die folgende
        Datenschutzerklärung besser verstehen.</p>
      <h3 class="adsimple-321190275">Was genau sind Cookies?</h3>
      <p class="text-dark">Immer wenn Sie durch das Internet surfen, verwenden Sie einen Browser. Bekannte
        Browser sind beispielsweise Chrome, Safari, Firefox, Internet Explorer und Microsoft Edge. Die
        meisten Webseiten speichern kleine Text-Dateien in Ihrem Browser. Diese Dateien nennt man
        Cookies.</p>
      <p class="text-dark">Eines ist nicht von der Hand zu weisen: Cookies sind echt nützliche Helferlein.
        Fast alle Webseiten verwendeten Cookies. Genauer gesprochen sind es HTTP-Cookies, da es auch noch
        verschiedene andere Cookies für andere Anwendungsbereiche gibt. HTTP-Cookies sind kleine Dateien,
        die von unserer Website auf Ihrem Computer gespeichert werden. Diese Cookie-Dateien werden
        automatisch im Cookie-Ordner, quasi dem &#8220;Hirn&#8221; Ihres Browsers, untergebracht. Ein Cookie
        besteht aus einem Namen und einem Wert. Bei der Definition eines Cookies müssen zusätzlich ein oder
        mehrere Attribute angegeben werden.</p>
      <p class="text-dark">Cookies speichern gewisse Nutzerdaten von Ihnen, wie beispielsweise Sprache oder
        persönliche Seiteneinstellungen. Wenn Sie unsere Seite wieder aufrufen, übermittelt Ihr Browser die
        „userbezogenen“ Informationen an unsere Seite zurück. Dank der Cookies weiß unsere Website, wer Sie
        sind und bietet Ihnen Ihre gewohnte Standardeinstellung. In einigen Browsern hat jedes Cookie eine
        eigene Datei, in anderen wie beispielsweise Firefox sind alle Cookies in einer einzigen Datei
        gespeichert.</p>
      <p class="text-dark">Es gibt sowohl Erstanbieter Cookies als auch Drittanbieter-Cookies.
        Erstanbieter-Cookies werden direkt von unserer Seite erstellt, Drittanbieter-Cookies werden von
        Partner-Webseiten (z.B. Google Analytics) erstellt. Jedes Cookie ist individuell zu bewerten, da
        jedes Cookie andere Daten speichert. Auch die Ablaufzeit eines Cookies variiert von ein paar Minuten
        bis hin zu ein paar Jahren. Cookies sind keine Software-Programme und enthalten keine Viren,
        Trojaner oder andere „Schädlinge“. Cookies können auch nicht auf Informationen Ihres PCs
        zugreifen.</p>
      <p class="text-dark">So können zum Beispiel Cookie-Daten aussehen:</p>
      <ul class="adsimple-321190275">
        <li class="adsimple-321190275">Name: _ga</li>
        <li class="adsimple-321190275">Ablaufzeit: 2 Jahre</li>
        <li class="adsimple-321190275">Verwendung: Unterscheidung der Webseitenbesucher</li>
        <li class="adsimple-321190275">Beispielhafter Wert: GA1.2.1326744211.152321190275</li>
      </ul>
      <p class="text-dark">Ein Browser sollte folgende Mindestgrößen unterstützen:</p>
      <ul class="adsimple-321190275">
        <li class="adsimple-321190275">Ein Cookie soll mindestens 4096 Bytes enthalten können</li>
        <li class="adsimple-321190275">Pro Domain sollen mindestens 50 Cookies gespeichert werden können
        </li>
        <li class="adsimple-321190275">Insgesamt sollen mindestens 3000 Cookies gespeichert werden können
        </li>
      </ul>
      <h3 class="adsimple-321190275">Welche Arten von Cookies gibt es?</h3>
      <p class="text-dark">Die Frage welche Cookies wir im Speziellen verwenden, hängt von den verwendeten
        Diensten ab und wird in der folgenden Abschnitten der Datenschutzerklärung geklärt. An dieser Stelle
        möchten wir kurz auf die verschiedenen Arten von HTTP-Cookies eingehen.</p>
      <p class="text-dark">Man kann 4 Arten von Cookies unterscheiden:</p>
      <p class="text-dark">
        <strong class="adsimple-321190275">Unbedingt notwendige Cookies<br/>
        </strong>Diese Cookies sind nötig, um grundlegende Funktionen der Website sicherzustellen. Zum
        Beispiel braucht es diese Cookies, wenn ein User ein Produkt in den Warenkorb legt, dann auf anderen
        Seiten weitersurft und später erst zur Kasse geht. Durch diese Cookies wird der Warenkorb nicht
        gelöscht, selbst wenn der User sein Browserfenster schließt.</p>
      <p class="text-dark">
        <strong class="adsimple-321190275">Funktionelle Cookies<br/>
        </strong>Diese Cookies sammeln Infos über das Userverhalten und ob der User etwaige Fehlermeldungen
        bekommt. Zudem werden mithilfe dieser Cookies auch die Ladezeit und das Verhalten der Website bei
        verschiedenen Browsern gemessen.</p>
      <p class="text-dark">
        <strong class="adsimple-321190275">Zielorientierte Cookies<br/>
        </strong>Diese Cookies sorgen für eine bessere Nutzerfreundlichkeit. Beispielsweise werden
        eingegebene Standorte, Schriftgrößen oder Formulardaten gespeichert.</p>
      <p class="text-dark">
        <strong class="adsimple-321190275">Werbe-Cookies<br/>
        </strong>Diese Cookies werden auch Targeting-Cookies genannt. Sie dienen dazu dem User individuell
        angepasste Werbung zu liefern. Das kann sehr praktisch, aber auch sehr nervig sein.</p>
      <p class="text-dark">Üblicherweise werden Sie beim erstmaligen Besuch einer Webseite gefragt, welche
        dieser Cookiearten Sie zulassen möchten. Und natürlich wird diese Entscheidung auch in einem Cookie
        gespeichert.</p>
      <h3 class="adsimple-321190275">Wie kann ich Cookies löschen?</h3>
      <p class="text-dark">Wie und ob Sie Cookies verwenden wollen, entscheiden Sie selbst. Unabhängig von
        welchem Service oder welcher Website die Cookies stammen, haben Sie immer die Möglichkeit Cookies zu
        löschen, nur teilweise zuzulassen oder zu deaktivieren. Zum Beispiel können Sie Cookies von
        Drittanbietern blockieren, aber alle anderen Cookies zulassen.</p>
      <p class="text-dark">Wenn Sie feststellen möchten, welche Cookies in Ihrem Browser gespeichert wurden,
        wenn Sie Cookie-Einstellungen ändern oder löschen wollen, können Sie dies in Ihren
        Browser-Einstellungen finden:</p>
      <p class="text-dark">
        <a class="adsimple-321190275" href="https://support.google.com/chrome/answer/95647?tid=321190275"
           target="_blank" rel="noopener">Chrome: Cookies in Chrome löschen, aktivieren und verwalten</a>
      </p>
      <p class="text-dark">
        <a class="adsimple-321190275"
           href="https://support.apple.com/de-at/guide/safari/sfri11471/mac?tid=321190275" target="_blank"
           rel="noopener">Safari: Verwalten von Cookies und Websitedaten mit Safari</a>
      </p>
      <p class="text-dark">
        <a class="adsimple-321190275"
           href="https://support.mozilla.org/de/kb/cookies-und-website-daten-in-firefox-loschen?tid=321190275"
           target="_blank" rel="noopener">Firefox: Cookies löschen, um Daten zu entfernen, die Websites auf
          Ihrem Computer abgelegt haben</a>
      </p>
      <p class="text-dark">
        <a class="adsimple-321190275"
           href="https://support.microsoft.com/de-at/help/17442/windows-internet-explorer-delete-manage-cookies?tid=321190275"
           target="_blank" rel="noopener">Internet Explorer: Löschen und Verwalten von Cookies</a>
      </p>
      <p class="text-dark">
        <a class="adsimple-321190275"
           href="https://support.microsoft.com/de-at/help/4027947/windows-delete-cookies?tid=321190275"
           target="_blank" rel="noopener">Microsoft Edge: Löschen und Verwalten von Cookies</a>
      </p>
      <p class="text-dark">Falls Sie grundsätzlich keine Cookies haben wollen, können Sie Ihren Browser so
        einrichten, dass er Sie immer informiert, wenn ein Cookie gesetzt werden soll. So können Sie bei
        jedem einzelnen Cookie entscheiden, ob Sie das Cookie erlauben oder nicht. Die Vorgangsweise ist je
        nach Browser verschieden. Am besten ist es Sie suchen die Anleitung in Google mit dem Suchbegriff
        “Cookies löschen Chrome” oder &#8220;Cookies deaktivieren Chrome&#8221; im Falle eines Chrome
        Browsers oder tauschen das Wort &#8220;Chrome&#8221; gegen den Namen Ihres Browsers, z.B. Edge,
        Firefox, Safari aus.</p>
      <h3 class="adsimple-321190275">Wie sieht es mit meinem Datenschutz aus?</h3>
      <p class="text-dark">Seit 2009 gibt es die sogenannten „Cookie-Richtlinien“. Darin ist festgehalten,
        dass das Speichern von Cookies eine Einwilligung von Ihnen verlangt. Innerhalb der EU-Länder gibt es
        allerdings noch sehr unterschiedliche Reaktionen auf diese Richtlinien. In Deutschland wurden die
        Cookie-Richtlinien nicht als nationales Recht umgesetzt. Stattdessen erfolgte die Umsetzung dieser
        Richtlinie weitgehend in § 15 Abs.3 des Telemediengesetzes (TMG).</p>
      <p class="text-dark">Wenn Sie mehr über Cookies wissen möchten und technischen Dokumentationen nicht
        scheuen, empfehlen wir <a class="adsimple-321190275" href="https://tools.ietf.org/html/rfc6265"
                                  target="_blank" rel="nofollow noopener">https://tools.ietf.org/html/rfc6265</a>,
        dem Request for Comments der Internet Engineering Task Force (IETF) namens &#8220;HTTP State
        Management Mechanism&#8221;.</p>
      <h2 class="adsimple-321190275">Speicherung persönlicher Daten</h2>
      <p class="text-dark">Persönliche Daten, die Sie uns auf dieser Website elektronisch übermitteln, wie zum
        Beispiel Name, E-Mail-Adresse, Adresse oder andere persönlichen Angaben im Rahmen der Übermittlung
        des LabyHelp Addons und der Benutzung, werden von uns gemeinsam mit der Spieler UUID und der
        IP-Adresse oder auch spezifische Minecraft Daten wie Online Status oder die aktive Server Adresse nur zum jeweils angegebenen Zweck verwendet, sicher verwahrt und nicht an Dritte
        weitergegeben.</p>
      <p class="text-dark">Wir nutzen Ihre persönlichen Daten somit nur für die Kommunikation mit jenen
        Besuchern/LabyHelp Addon Nutzern, die Kontakt ausdrücklich wünschen und für die Abwicklung der auf dieser Webseite
        angebotenen Dienstleistungen und Produkte. Wir geben Ihre persönlichen Daten ohne Zustimmung nicht
        weiter, können jedoch nicht ausschließen, dass diese Daten beim Vorliegen von rechtswidrigem
        Verhalten eingesehen werden.</p>
      <p class="text-dark">Wenn Sie uns persönliche Daten per E-Mail schicken &#8211; somit abseits dieser
        Webseite &#8211; können wir keine sichere Übertragung und den Schutz Ihrer Daten garantieren. Wir
        empfehlen Ihnen, vertrauliche Daten niemals unverschlüsselt per E-Mail zu übermitteln.</p>
      <p class="text-dark">Die Rechtsgrundlage besteht nach <a class="adsimple-321190275"
                                                               href="https://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&amp;from=DE&amp;tid=321190275"
                                                               target="_blank" rel="noopener">Artikel 6 Absatz
        1 a DSGVO</a> (Rechtmäßigkeit der Verarbeitung) darin, dass Sie uns die Einwilligung zur
        Verarbeitung der von Ihnen eingegebenen Daten geben. Sie können diesen Einwilligung jederzeit
        widerrufen &#8211; eine formlose E-Mail reicht aus, Sie finden unsere Kontaktdaten im Impressum.</p>
      <h2 class="adsimple-321190275">Rechte laut Datenschutzgrundverordnung</h2>
      <p class="text-dark">Ihnen stehen laut den Bestimmungen der DSGVO grundsätzlich die folgende Rechte
        zu:</p>
      <ul class="adsimple-321190275">
        <li class="adsimple-321190275">Recht auf Berichtigung (Artikel 16 DSGVO)</li>
        <li class="adsimple-321190275">Recht auf Löschung („Recht auf Vergessenwerden“) (Artikel 17 DSGVO)
        </li>
        <li class="adsimple-321190275">Recht auf Einschränkung der Verarbeitung (Artikel 18 DSGVO)</li>
        <li class="adsimple-321190275">Recht auf Benachrichtigung &#8211; Mitteilungspflicht im Zusammenhang
          mit der Berichtigung oder Löschung personenbezogener Daten oder der Einschränkung der
          Verarbeitung (Artikel 19 DSGVO)
        </li>
        <li class="adsimple-321190275">Recht auf Datenübertragbarkeit (Artikel 20 DSGVO)</li>
        <li class="adsimple-321190275">Widerspruchsrecht (Artikel 21 DSGVO)</li>
        <li class="adsimple-321190275">Recht, nicht einer ausschließlich auf einer automatisierten
          Verarbeitung — einschließlich Profiling — beruhenden Entscheidung unterworfen zu werden (Artikel
          22 DSGVO)
        </li>
      </ul>
      <p class="text-dark">Wenn Sie glauben, dass die Verarbeitung Ihrer Daten gegen das Datenschutzrecht
        verstößt oder Ihre datenschutzrechtlichen Ansprüche sonst in einer Weise verletzt worden sind,
        können Sie sich an die <a class="adsimple-321190275" href="https://www.bfdi.bund.de" target="_blank"
                                  rel="noopener">Bundesbeauftragte für den Datenschutz und die
          Informationsfreiheit (BfDI)</a> wenden.</p>
      <h2 class="adsimple-321190275">TLS-Verschlüsselung mit https</h2>
      <p class="text-dark">Wir verwenden https um Daten abhörsicher im Internet zu übertragen (Datenschutz
        durch Technikgestaltung <a class="adsimple-321190275"
                                   href="https://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&amp;from=DE&amp;tid=321190275"
                                   target="_blank" rel="noopener">Artikel 25 Absatz 1 DSGVO</a>). Durch den
        Einsatz von TLS (Transport Layer Security), einem Verschlüsselungsprotokoll zur sicheren
        Datenübertragung im Internet können wir den Schutz vertraulicher Daten sicherstellen. Sie erkennen
        die Benutzung dieser Absicherung der Datenübertragung am kleinen Schloßsymbol links oben im Browser
        und der Verwendung des Schemas https (anstatt http) als Teil unserer Internetadresse.</p>
      <h2 class="adsimple-321190275">Eingebettete Social Media Elemente Datenschutzerklärung</h2>
      <p class="text-dark">Wir binden auf unserer Webseite Elemente von Social Media Diensten ein um Bilder,
        Videos und Texte anzuzeigen.<br/>
        Durch den Besuch von Seiten die diese Elemente darstellen, werden Daten von Ihrem Browser zum
        jeweiligen Social Media Dienst übertragen und dort gespeichert. Wir haben keinen Zugriff auf diese
        Daten.<br/>
        Die folgenden Links führen Sie zu den Seiten der jeweiligen Social Media Dienste wo erklärt wird,
        wie diese mit Ihren Daten umgehen:</p>
      <ul class="adsimple-321190275">
        <li class="adsimple-321190275">Instagram-Datenschutzrichtlinie: <a class="adsimple-321190275"
                                                                           href="https://help.instagram.com/519522125107875?tid=321190275"
                                                                           target="_blank" rel="noopener">https://help.instagram.com/519522125107875</a>
        </li>
        <li class="adsimple-321190275">Für YouTube gilt die Google Datenschutzerklärung: <a
            class="adsimple-321190275"
            href="https://policies.google.com/privacy?hl=de&amp;tid=321190275" target="_blank"
            rel="noopener">https://policies.google.com/privacy?hl=de</a>
        </li>
        <li class="adsimple-321190275">Facebook-Datenrichtline: <a class="adsimple-321190275"
                                                                   href="https://www.facebook.com/about/privacy?tid=321190275"
                                                                   target="_blank" rel="noopener">https://www.facebook.com/about/privacy</a>
        </li>
        <li class="adsimple-321190275">Twitter Datenschutzrichtlinie: <a class="adsimple-321190275"
                                                                         href="https://twitter.com/de/privacy?tid=321190275"
                                                                         target="_blank" rel="noopener">https://twitter.com/de/privacy</a>
        </li>
      </ul>
      <h2 class="adsimple-321190275">Instagram Datenschutzerklärung</h2>
      <p class="text-dark">Wir haben auf unserer Webseite Funktionen von Instagram eingebaut. Instagram ist
        eine Social Media Plattform des Unternehmens Instagram LLC, 1601 Willow Rd, Menlo Park CA 94025,
        USA. Instagram ist seit 2012 ein Tochterunternehmen von Facebook Inc. und gehört zu den
        Facebook-Produkten. Das Einbetten von Instagram-Inhalten auf unserer Webseite nennt man Embedding.
        Dadurch können wir Ihnen Inhalte wie Buttons, Fotos oder Videos von Instagram direkt auf unserer
        Webseite zeigen. Wenn Sie Webseiten unserer Webpräsenz aufrufen, die eine Instagram-Funktion
        integriert haben, werden Daten an Instagram übermittelt, gespeichert und verarbeitet. Instagram
        verwendet dieselben Systeme und Technologien wie Facebook. Ihre Daten werden somit über alle
        Facebook-Firmen hinweg verarbeitet.</p>
      <p class="text-dark">Im Folgenden wollen wir Ihnen einen genaueren Einblick geben, warum Instagram Daten
        sammelt, um welche Daten es sich handelt und wie Sie die Datenverarbeitung weitgehend kontrollieren
        können. Da Instagram zu Facebook Inc. gehört, beziehen wir unsere Informationen einerseits von den
        Instagram-Richtlinien, andererseits allerdings auch von den Facebook-Datenrichtlinien selbst.</p>
      <h3 class="adsimple-321190275">Was ist Instagram?</h3>
      <p class="text-dark">Instagram ist eines der bekanntesten Social Media Netzwerken weltweit. Instagram
        kombiniert die Vorteile eines Blogs mit den Vorteilen von audiovisuellen Plattformen wie YouTube
        oder Vimeo. Sie können auf „Insta“ (wie viele der User die Plattform salopp nennen) Fotos und kurze
        Videos hochladen, mit verschiedenen Filtern bearbeiten und auch in anderen sozialen Netzwerken
        verbreiten. Und wenn Sie selbst nicht aktiv sein wollen, können Sie auch nur anderen interessante
        Users folgen.</p>
      <h3 class="adsimple-321190275">Warum verwenden wir Instagram auf unserer Webseite?</h3>
      <p class="text-dark">Instagram ist jene Social Media Plattform, die in den letzten Jahren so richtig
        durch die Decke ging. Und natürlich haben auch wir auf diesen Boom reagiert. Wir wollen, dass Sie
        sich auf unserer Webseite so wohl wie möglich fühlen. Darum ist für uns eine abwechslungsreiche
        Aufbereitung unserer Inhalte selbstverständlich. Durch die eingebetteten Instagram-Funktionen können
        wir unseren Content mit hilfreichen, lustigen oder spannenden Inhalten aus der Instagram-Welt
        bereichern. Da Instagram eine Tochtergesellschaft von Facebook ist, können uns die erhobenen Daten
        auch für personalisierte Werbung auf Facebook dienlich sein. So bekommen unsere Werbeanzeigen nur
        Menschen, die sich wirklich für unsere Produkte oder Dienstleistungen interessieren.</p>
      <p class="text-dark">Instagram nützt die gesammelten Daten auch zu Messungs- und Analysezwecken. Wir
        bekommen zusammengefasste Statistiken und so mehr Einblick über Ihre Wünsche und Interessen. Wichtig
        ist zu erwähnen, dass diese Berichte Sie nicht persönlich identifizieren.</p>
      <h3 class="adsimple-321190275">Welche Daten werden von Instagram gespeichert?</h3>
      <p class="text-dark">Wenn Sie auf eine unserer Seiten stoßen, die Instagram-Funktionen (wie
        Instagrambilder oder Plug-ins) eingebaut haben, setzt sich Ihr Browser automatisch mit den Servern
        von Instagram in Verbindung. Dabei werden Daten an Instagram versandt, gespeichert und verarbeitet.
        Und zwar unabhängig, ob Sie ein Instagram-Konto haben oder nicht. Dazu zählen Informationen über
        unserer Webseite, über Ihren Computer, über getätigte Käufe, über Werbeanzeigen, die Sie sehen und
        wie Sie unser Angebot nutzen. Weiters werden auch Datum und Uhrzeit Ihrer Interaktion mit Instagram
        gespeichert. Wenn Sie ein Instagram-Konto haben bzw. eingeloggt sind, speichert Instagram deutlich
        mehr Daten über Sie.</p>
      <p class="text-dark">Facebook unterscheidet zwischen Kundendaten und Eventdaten. Wir gehen davon aus,
        dass dies bei Instagram genau so der Fall ist. Kundendaten sind zum Beispiel Name, Adresse,
        Telefonnummer und IP-Adresse. Wichtig zu erwähnen ist, dass diese Kundendaten erst an Instagram
        übermittelt werden, wenn Sie zuvor „gehasht“ wurden. Hashing meint, ein Datensatz wird in eine
        Zeichenkette verwandelt. Dadurch kann man die Kontaktdaten verschlüsseln. Zudem werden auch die oben
        genannten „Event-Daten“ übermittelt. Unter „Event-Daten“ versteht Facebook – und folglich auch
        Instagram – Daten über Ihr Userverhalten. Es kann auch vorkommen, dass Kontaktdaten mit Event-Daten
        kombiniert werden. Die erhobenen Kontaktdaten werden mit den Daten, die Instagram bereits von Ihnen
        hat abgeglichen.</p>
      <p class="text-dark">Über kleine Text-Dateien (Cookies), die meist in Ihrem Browser gesetzt werden,
        werden die gesammelten Daten an Facebook übermittelt. Je nach verwendeten Instagram-Funktionen und
        ob Sie selbst ein Instagram-Konto haben, werden unterschiedlich viele Daten gespeichert.</p>
      <p class="text-dark">Wir gehen davon aus, dass bei Instagram die Datenverarbeitung gleich funktioniert
        wie bei Facebook. Das bedeutet: wenn Sie ein Instagram-Konto haben oder <a
            class="adsimple-321190275" href="http://www.instagram.com?tid=321190275" target="_blank"
            rel="noopener">www.instagram.com</a> besucht haben, hat Instagram zumindest ein Cookie
        gesetzt. Wenn das der Fall ist, sendet Ihr Browser über das Cookie Infos an Instagram, sobald Sie
        mit einer Instagram-Funktion in Berührung kommen. Spätestens nach 90 Tagen (nach Abgleichung) werden
        diese Daten wieder gelöscht bzw. anonymisiert. Obwohl wir uns intensiv mit der Datenverarbeitung von
        Instagram beschäftigt haben, können wir nicht ganz genau sagen, welche Daten Instagram exakt sammelt
        und speichert.</p>
      <p class="text-dark">Im Folgenden zeigen wir Ihnen Cookies, die in Ihrem Browser mindestens gesetzt
        werden, wenn Sie auf eine Instagram-Funktion (wie z.B. Button oder ein Insta-Bild) klicken. Bei
        unserem Test gehen wir davon aus, dass Sie kein Instagram-Konto haben. Wenn Sie bei Instagram
        eingeloggt sind, werden natürlich deutlich mehr Cookies in Ihrem Browser gesetzt.</p>
      <p class="text-dark">Diese Cookies wurden bei unserem Test verwendet:</p>
      <p class="text-dark">
        <strong class="adsimple-321190275">Name: </strong>csrftoken<br/>
        <strong class="adsimple-321190275">Wert: </strong>&#8220;&#8221;<br/>
        <strong class="adsimple-321190275">Verwendungszweck: </strong>Dieses Cookie wird mit hoher
        Wahrscheinlichkeit aus Sicherheitsgründen gesetzt, um Fälschungen von Anfragen zu verhindern.
        Genauer konnten wir das allerdings nicht in Erfahrung bringen.<br/>
        <strong class="adsimple-321190275">Ablaufdatum:</strong> nach einem Jahr</p>
      <p class="text-dark">
        <strong class="adsimple-321190275">Name: </strong>mid<br/>
        <strong class="adsimple-321190275">Wert: </strong>&#8220;&#8221;<br/>
        <strong class="adsimple-321190275">Verwendungszweck: </strong>Instagram setzt dieses Cookie, um die
        eigenen Dienstleistungen und Angebote in und außerhalb von Instagram zu optimieren. Das Cookie legt
        eine eindeutige User-ID fest.<br/>
        <strong class="adsimple-321190275">Ablaufdatum:</strong> nach Ende der Sitzung</p>
      <p class="text-dark">
        <strong class="adsimple-321190275">Name:</strong> fbsr_321190275124024<br/>
        <strong class="adsimple-321190275">Wert: </strong>keine Angaben<br/>
        <strong class="adsimple-321190275">Verwendungszweck: </strong>Dieses Cookie speichert die
        Log-in-Anfrage für User der Instagram-App.<strong class="adsimple-321190275">
        <br/>
      </strong>
        <strong class="adsimple-321190275">Ablaufdatum:</strong> nach Ende der Sitzung</p>
      <p class="text-dark">
        <strong class="adsimple-321190275">Name:</strong> rur<br/>
        <strong class="adsimple-321190275">Wert: </strong>ATN<br/>
        <strong class="adsimple-321190275">Verwendungszweck: </strong>Dabei handelt es sich um ein
        Instagram-Cookie, das die Funktionalität auf Instagram gewährleistet.<br/>
        <strong class="adsimple-321190275">Ablaufdatum:</strong> nach Ende der Sitzung</p>
      <p class="text-dark">
        <strong class="adsimple-321190275">Name:</strong> urlgen<br/>
        <strong class="adsimple-321190275">Wert: </strong>&#8220;{\&#8221;194.96.75.33\&#8221;:
        1901}:1iEtYv:Y833k2_UjKvXgYe321190275&#8221;<br/>
        <strong class="adsimple-321190275">Verwendungszweck: </strong>Dieses Cookie dient den
        Marketingzwecken von Instagram.<br/>
        <strong class="adsimple-321190275">Ablaufdatum:</strong> nach Ende der Sitzung</p>
      <p class="text-dark">
        <strong class="adsimple-321190275">Anmerkung:</strong> Wir können hier keinen
        Vollständigkeitsanspruch erheben. Welche Cookies im individuellen Fall gesetzt werden, hängt von den
        eingebetteten Funktionen und Ihrer Verwendung von Instagram ab.</p>
      <h3 class="adsimple-321190275">Wie lange und wo werden die Daten gespeichert?</h3>
      <p class="text-dark">Instagram teilt die erhaltenen Informationen zwischen den Facebook-Unternehmen mit
        externen Partnern und mit Personen, mit denen Sie sich weltweit verbinden. Die Datenverarbeitung
        erfolgt unter Einhaltung der eigenen Datenrichtlinie. Ihre Daten sind, unter anderem aus
        Sicherheitsgründen, auf den Facebook-Servern auf der ganzen Welt verteilt. Die meisten dieser Server
        stehen in den USA.</p>
      <h3 class="adsimple-321190275">Wie kann ich meine Daten löschen bzw. die Datenspeicherung
        verhindern?</h3>
      <p class="text-dark">Dank der Datenschutz Grundverordnung haben Sie das Recht auf Auskunft,
        Übertragbarkeit, Berichtigung und Löschung Ihrer Daten. In den Instagram-Einstellungen können Sie
        Ihre Daten verwalten. Wenn Sie Ihre Daten auf Instagram völlig löschen wollen, müssen Sie Ihr
        Instagram-Konto dauerhaft löschen.</p>
      <p class="text-dark">Und so funktioniert die Löschung des Instagram-Kontos:</p>
      <p class="text-dark">Öffnen Sie zuerst die Instagram-App. Auf Ihrer Profilseite gehen Sie nach unten und
        klicken Sie auf „Hilfebereich“. Jetzt kommen Sie auf die Webseite des Unternehmens. Klicken Sie auf
        der Webseite auf „Verwalten des Kontos“ und dann auf „Dein Konto löschen“.</p>
      <p class="text-dark">Wenn Sie Ihr Konto ganz löschen, löscht Instagram Posts wie beispielsweise Ihre
        Fotos und Status-Updates. Informationen, die andere Personen über Sie geteilt haben, gehören nicht
        zu Ihrem Konto und werden folglich nicht gelöscht.</p>
      <p class="text-dark">Wie bereits oben erwähnt, speichert Instagram Ihre Daten in erster Linie über
        Cookies. Diese Cookies können Sie in Ihrem Browser verwalten, deaktivieren oder löschen. Abhängig
        von Ihrem Browser funktioniert die Verwaltung immer ein bisschen anders. Hier zeigen wir Ihnen die
        Anleitungen der wichtigsten Browser.</p>
      <p class="text-dark">
        <a class="adsimple-321190275" href="https://support.google.com/chrome/answer/95647?tid=321190275"
           target="_blank" rel="noopener">Chrome: Cookies in Chrome löschen, aktivieren und verwalten</a>
      </p>
      <p class="text-dark">
        <a class="adsimple-321190275"
           href="https://support.apple.com/de-at/guide/safari/sfri11471/mac?tid=321190275" target="_blank"
           rel="noopener">Safari: Verwalten von Cookies und Websitedaten mit Safari</a>
      </p>
      <p class="text-dark">
        <a class="adsimple-321190275"
           href="https://support.mozilla.org/de/kb/cookies-und-website-daten-in-firefox-loschen?tid=321190275"
           target="_blank" rel="noopener">Firefox: Cookies löschen, um Daten zu entfernen, die Websites auf
          Ihrem Computer abgelegt haben</a>
      </p>
      <p class="text-dark">
        <a class="adsimple-321190275"
           href="https://support.microsoft.com/de-at/help/17442/windows-internet-explorer-delete-manage-cookies?tid=321190275"
           target="_blank" rel="noopener">Internet Explorer: Löschen und Verwalten von Cookies</a>
      </p>
      <p class="text-dark">
        <a class="adsimple-321190275"
           href="https://support.microsoft.com/de-at/help/4027947/windows-delete-cookies?tid=321190275"
           target="_blank" rel="noopener">Microsoft Edge: Löschen und Verwalten von Cookies</a>
      </p>
      <p class="text-dark">Sie können auch grundsätzlich Ihren Browser so einrichten, dass Sie immer
        informiert werden, wenn ein Cookie gesetzt werden soll. Dann können Sie immer individuell
        entscheiden, ob Sie das Cookie zulassen wollen oder nicht.</p>
      <p class="text-dark">Instagram ist ein Tochterunternehmen von Facebook Inc. und Facebook ist aktiver
        Teilnehmer beim EU-U.S. Privacy Shield Framework. Dieses Framework stellt eine korrekte
        Datenübertragung zwischen den USA und der Europäischen Union sicher. Unter <a
            class="adsimple-321190275"
            href="https://www.privacyshield.gov/participant?id=a2zt0000000GnywAAC" target="_blank"
            rel="noopener">https://www.privacyshield.gov/participant?id=a2zt0000000GnywAAC</a> erfahren
        Sie mehr darüber. Wir haben versucht, Ihnen die wichtigsten Informationen über die Datenverarbeitung
        durch Instagram näherzubringen. Auf <a class="adsimple-321190275"
                                               href="https://help.instagram.com/519522125107875"
                                               target="_blank" rel="noopener">https://help.instagram.com/519522125107875</a>
        <br/>
        können Sie sich noch näher mit den Datenrichtlinien von Instagram auseinandersetzen.</p>
      <h2 class="adsimple-321190275">Twitter Datenschutzerklärung</h2>
      <p class="text-dark">Auf unserer Webseite haben wir Funktionen von Twitter eingebaut. Dabei handelt es
        sich zum Beispiel um eingebettete Tweets, Timelines, Buttons oder Hashtags. Twitter ist ein
        Kurznachrichtendienst und eine Social-Media-Plattform der Firma Twitter Inc., One Cumberland Place,
        Fenian Street, Dublin 2 D02 AX07, Irland.</p>
      <p class="text-dark">Nach unserer Kenntnis werden im Europäischen Wirtschaftsraum und in der Schweiz
        durch das bloße Einbinden von Twitter-Funktion noch keine personenbezogenen Daten oder Daten zu
        Ihrer Webaktivitäten an Twitter übertragen. Erst wenn Sie mit den Twitter-Funktionen interagieren,
        wie zum Beispiel auf einen Button klicken, können Daten an Twitter gesendet, dort gespeichert und
        verarbeitet werden. Auf diese Datenverarbeitung haben wir keinen Einfluss und tragen keine
        Verantwortung. Im Rahmen dieser Datenschutzerklärung wollen wir Ihnen einen Überblick geben, welche
        Daten Twitter speichert, was Twitter mit diesen Daten macht und wie Sie sich vor der
        Datenübertragung weitgehend schützen können.</p>
      <h3 class="adsimple-321190275">Was ist Twitter?</h3>
      <p class="text-dark">Für die einen ist Twitter ein Nachrichtendienst, für andere eine
        Social-Media-Plattform und wieder andere sprechen von einem Microblogging-Dienst. All diese
        Bezeichnungen haben ihre Berechtigung und meinen mehr oder weniger dasselbe.</p>
      <p class="text-dark">Sowohl Privatpersonen als auch Unternehmen nützen Twitter, um mit interessierten
        Personen über Kurznachrichten zu kommunizieren. Pro Nachricht erlaubt Twitter nur 280 Zeichen. Diese
        Nachrichten werden „Tweets“ genannt. Anders als beispielsweise bei Facebook fokussiert sich der
        Dienst nicht auf den Ausbau eines Netzwerks für &#8220;Freunde&#8221;, sondern will als weltweite
        und offene Nachrichten-Plattform verstanden werden. Bei Twitter kann man auch ein anonymes Konto
        führen und Tweets können einerseits vom Unternehmen, andererseits von den Usern selbst gelöscht
        werden.</p>
      <h3 class="adsimple-321190275">Warum verwenden wir Twitter auf unserer Webseite?</h3>
      <p class="text-dark">Wie viele andere Webseiten und Unternehmen versuchen wir unserer Services und
        Dienstleistungen über verschiedene Kanäle anzubieten und mit unseren Kunden zu kommunizieren.
        Speziell Twitter ist uns als nützlicher „kleiner“ Nachrichtendienst ans Herz gewachsen. Immer wieder
        tweeten oder retweeten wir spannende, lustige oder interessante Inhalte. Uns ist klar, dass Sie
        nicht jeden Kanal extra folgen können. Schließlich haben Sie auch noch etwas anderes zu tun. Darum
        haben wir auf unserer Webseite auch Twitter-Funktionen eingebunden. Sie können unsere
        Twitter-Aktivität „vor Ort“ miterleben oder über einen direkten Link zu unserer Twitter-Seite
        kommen. Durch die Einbindung wollen wir unser Service und die Nutzerfreundlichkeit auf unserer
        Webseite stärken.</p>
      <h3 class="adsimple-321190275">Welche Daten werden von Twitter gespeichert?</h3>
      <p class="text-dark">Auf manchen unserer Unterseiten finden Sie die eingebauten Twitter-Funktionen. Wenn
        Sie mit den Twitter-Inhalten interagieren, wie zum Beispiel auf einen Button klicken, kann Twitter
        Daten erfassen und speichern. Und zwar auch dann, wenn Sie selbst kein Twitter-Konto haben. Twitter
        nennt diese Daten &#8220;Log-Daten&#8221;. Dazu zählen demografische Daten, Browser-Cookie-IDs, die
        ID Ihres Smartphones, gehashte E-Mail-Adressen, und Informationen, welche Seiten Sie bei Twitter
        besucht haben und welche Handlungen Sie ausgeführt haben. Twitter speichert natürlich mehr Daten,
        wenn Sie ein Twitter-Konto haben und angemeldet sind. Meistens passiert diese Speicherung über
        Cookies. Cookies sind kleine Text-Dateien, die meist in Ihrem Browser gesetzt werden und
        unterschiedliche Information an Twitter übermitteln.</p>
      <p class="text-dark">Welche Cookies gesetzt werden, wenn Sie nicht bei Twitter angemeldet sind, aber
        eine Webseite mit eingebauten Twitter-Funktionen besuchen, zeigen wir Ihnen jetzt. Bitte betrachten
        Sie diese Aufzählung als Beispiel. Einen Anspruch auf Vollständigkeit können wir hier auf keinen
        Fall gewährleisten, da sich die Wahl der Cookies stets verändert und von Ihren individuellen
        Handlungen mit den Twitter-Inhalten abhängt.</p>
      <p class="text-dark">Diese Cookies wurden bei unserem Test verwendet:</p>
      <p class="text-dark">
        <strong class="adsimple-321190275">Name:</strong> personalization_id<br/>
        <strong class="adsimple-321190275">Wert:</strong> &#8220;v1_cSJIsogU51SeE321190275&#8221;<br/>
        <strong class="adsimple-321190275">Verwendungszweck: </strong>Dieses Cookie speichert Informationen,
        wie Sie die Webseite nutzen und über welche Werbung Sie möglicherweise zu Twitter gekommen
        sind.<br/>
        <strong class="adsimple-321190275">Ablaufdatum:</strong> nach 2 Jahre</p>
      <p class="text-dark">
        <strong class="adsimple-321190275">Name: </strong>lang<br/>
        <strong class="adsimple-321190275">Wert: </strong>de<br/>
        <strong class="adsimple-321190275">Verwendungszweck: </strong>Dieses Cookie speichert Ihre
        voreingestellte bzw. bevorzugte Sprache.<br/>
        <strong class="adsimple-321190275">Ablaufdatum :</strong>nach Sitzungsende</p>
      <p class="text-dark">
        <strong class="adsimple-321190275">Name: </strong>guest_id<br/>
        <strong class="adsimple-321190275">Wert: </strong>321190275v1%3A157132626<br/>
        <strong class="adsimple-321190275">Verwendungszweck: </strong>Dieses Cookie wird gesetzt, um Sie als
        Gast zu identifizieren.<strong class="adsimple-321190275"></strong>
        <br/>
        <strong class="adsimple-321190275">Ablaufdatum: </strong>nach 2 Jahren</p>
      <p class="text-dark">
        <strong class="adsimple-321190275">Name: </strong>fm<br/>
        <strong class="adsimple-321190275">Wert: </strong>0<br/>
        <strong class="adsimple-321190275">Verwendungszweck: </strong>Zu diesem Cookie konnten wir leider
        den Verwendungszweck nicht in Erfahrung bringen.<br/>
        <strong class="adsimple-321190275">Ablaufdatum: </strong>nach Sitzungsende</p>
      <p class="text-dark">
        <strong class="adsimple-321190275">Name: </strong>external_referer<br/>
        <strong class="adsimple-321190275">Wert: </strong>3211902752beTA0sf5lkMrlGt<br/>
        <strong class="adsimple-321190275">Verwendungszweck: </strong>Dieses Cookie sammelt anonyme Daten,
        wie zum Beispiel wie oft Sie Twitter besuchen und wie lange Sie Twitter besuchen.<br/>
        <strong class="adsimple-321190275">Ablaufdatum: </strong>Nach 6 Tagen</p>
      <p class="text-dark">
        <strong class="adsimple-321190275">Name: </strong>eu_cn<br/>
        <strong class="adsimple-321190275">Wert: </strong>1<br/>
        <strong class="adsimple-321190275">Verwendungszweck: </strong>Dieses Cookie speichert Useraktivität
        und dient diversen Werbezwecken von Twitter. <strong class="adsimple-321190275">
        <br/>
        Ablaufdatum: </strong>Nach einem Jahr</p>
      <p class="text-dark">
        <strong class="adsimple-321190275">Name: </strong>ct0<br/>
        <strong class="adsimple-321190275">Wert: </strong>c1179f07163a365d2ed7aad84c99d966<br/>
        <strong class="adsimple-321190275">Verwendungszweck: </strong>Zu diesem Cookie haben wir leider
        keine Informationen gefunden.<br/>
        <strong class="adsimple-321190275">Ablaufdatum: </strong>nach 6 Stunden</p>
      <p class="text-dark">
        <strong class="adsimple-321190275">Name: </strong>_twitter_sess<br/>
        <strong class="adsimple-321190275">Wert: </strong>53D%253D&#8211;dd0248321190275-<br/>
        <strong class="adsimple-321190275">Verwendungszweck: </strong>Mit diesem Cookie können Sie
        Funktionen innerhalb der Twitter-Webseite nutzen.<br/>
        <strong class="adsimple-321190275">Ablaufdatum: </strong>nach Sitzungsende</p>
      <p class="text-dark">
        <strong class="adsimple-321190275">Anmerkung:</strong> Twitter arbeitet auch mit Drittanbietern
        zusammen. Darum haben wir bei unsrem Test auch die drei Google-Analytics-Cookies _ga, _gat, _gid
        erkannt.</p>
      <p class="text-dark">Twitter verwendet die erhobenen Daten einerseits, um das Userverhalten besser zu
        verstehen und somit ihre eigenen Dienste und Werbeangebote zu verbessern, andererseits dienen die
        Daten auch internen Sicherheitsmaßnahmen.</p>
      <h3 class="adsimple-321190275">Wie lange und wo werden die Daten gespeichert?</h3>
      <p class="text-dark">Wenn Twitter Daten von anderen Webseiten erhebt, werden diese nach maximal 30 Tagen
        gelöscht, zusammengefasst oder auf andere Weise verdeckt. Die Twitter-Server liegen auf
        verschiedenen Serverzentren in den Vereinigten Staaten. Demnach ist davon auszugehen, dass erhobenen
        Daten in Amerika gesammelt und gespeichert werden. Nach unserer Recherche konnten wir nicht
        eindeutig feststellen, ob Twitter auch eigene Server in Europa hat. Grundsätzlich kann Twitter die
        erhobenen Daten speichern, bis sie dem Unternehmen nicht mehr dienlich sind, Sie die Daten löschen
        oder eine gesetzliche Löschfrist besteht.</p>
      <h3 class="adsimple-321190275">Wie kann ich meine Daten löschen bzw. die Datenspeicherung
        verhindern?</h3>
      <p class="text-dark">Twitter betont in seinen Datenschutzrichtlinien immer wieder, dass es keine Daten
        von externen Webseitenbesuchen speichert, wenn Sie bzw. Ihr Browser sich im europäischen
        Wirtschaftsraum oder in der Schweiz befinden. Falls Sie allerdings mit Twitter direkt interagieren,
        speichert Twitter selbstverständlich auch Daten von Ihnen.</p>
      <p class="text-dark">Wenn Sie ein Twitter-Konto besitzen, können Sie Ihre Daten verwalten, indem Sie
        unter dem „Profil“-Button auf „Mehr“ klicken. Anschließend klicken Sie auf „Einstellungen und
        Datenschutz“. Hier können Sie die Datenverarbeitung individuell verwalten.</p>
      <p class="text-dark">Wenn Sie kein Twitter-Konto besitzen, können Sie auf <a class="adsimple-321190275"
                                                                                   href="https://twitter.com/">twitter.com</a>
        gehen und dann auf „Individualisierung“ klicken. Unter dem Punkt „Individualisierung und Daten“
        können Sie Ihre erhobenen Daten verwalten.</p>
      <p class="text-dark">Die meisten Daten werden, wie oben bereits erwähnt, über Cookies gespeichert und
        die können Sie in Ihrem Browser verwalten, deaktivieren oder löschen. Bitte beachten Sie, dass Sie
        die Cookies nur in dem von Ihnen gewählten Browser &#8220;bearbeiten&#8221;. Das heißt: verwenden
        Sie in Zukunft einen anderen Browser, müssen Sie dort Ihre Cookies erneut nach Ihren Wünschen
        verwalten. Hier gibt es die Anleitung zur Cookie-Verwaltung der bekanntesten Browser.</p>
      <p class="text-dark">
        <a class="adsimple-321190275" href="https://support.google.com/chrome/answer/95647?tid=321190275"
           target="_blank" rel="noopener noreferrer">Chrome: Cookies in Chrome löschen, aktivieren und
          verwalten</a>
      </p>
      <p class="text-dark">
        <a class="adsimple-321190275"
           href="https://support.apple.com/de-at/guide/safari/sfri11471/mac?tid=321190275" target="_blank"
           rel="noopener noreferrer">Safari: Verwalten von Cookies und Websitedaten mit Safari</a>
      </p>
      <p class="text-dark">
        <a class="adsimple-321190275"
           href="https://support.mozilla.org/de/kb/cookies-und-website-daten-in-firefox-loschen?tid=321190275"
           target="_blank" rel="noopener noreferrer">Firefox: Cookies löschen, um Daten zu entfernen, die
          Websites auf Ihrem Computer abgelegt haben</a>
      </p>
      <p class="text-dark">
        <a class="adsimple-321190275"
           href="https://support.microsoft.com/de-at/help/17442/windows-internet-explorer-delete-manage-cookies?tid=321190275"
           target="_blank" rel="noopener noreferrer">Internet Explorer: Löschen und Verwalten von
          Cookies</a>
      </p>
      <p class="text-dark">
        <a class="adsimple-321190275"
           href="https://support.microsoft.com/de-at/help/4027947/windows-delete-cookies?tid=321190275"
           target="_blank" rel="noopener noreferrer">Microsoft Edge: Löschen und Verwalten von Cookies</a>
      </p>
      <p class="text-dark">Ihren Browser können Sie auch so verwalten, dass Sie bei jedem einzelnen Cookie
        informiert werden. Dann können Sie immer individuell entscheiden, ob Sie ein Cookie zulassen oder
        nicht.</p>
      <p class="text-dark">Twitter verwendet die Daten auch für personalisierte Werbung in- und außerhalb von
        Twitter. In den Einstellungen können Sie unter „Individualisierung und Daten“ die personalisierte
        Werbung abschalten. Wenn Sie Twitter auf einem Browser nutzen, können Sie die personalisierte
        Werbung unter <a class="adsimple-321190275" href="http://optout.aboutads.info/?c=2&amp;lang=EN"
                         target="_blank" rel="follow noopener noreferrer">http://optout.aboutads.info/?c=2&amp;lang=EN</a>
        deaktivieren.</p>
      <p class="text-dark">Twitter ist aktiver Teilnehmer beim EU-U.S. Privacy Shield Framework. Dieses
        Framework stellt eine korrekte Datenübertragung zwischen den USA und der Europäischen Union sicher.
        Unter <a class="adsimple-321190275"
                 href="https://www.privacyshield.gov/participant?id=a2zt0000000TORzAAO" target="_blank"
                 rel="noopener noreferrer">https://www.privacyshield.gov/participant?id=a2zt0000000TORzAAO</a>
        erfahren Sie mehr darüber.</p>
      <p class="text-dark">Wir hoffen, wir haben Ihnen einen grundsätzlichen Überblick über die
        Datenverarbeitung durch Twitter gegeben. Wir erhalten keinen Daten von Twitter und tragen auch keine
        Verantwortung darüber, was Twitter mit Ihren Daten macht. Falls Sie noch weitere Fragen zu diesem
        Thema haben, empfehlen wir Ihnen die Twitter-Datenschutzerklärung unter <a
            class="adsimple-321190275" href="https://twitter.com/de/privacy">https://twitter.com/de/privacy</a>.
      </p>
      <h2 class="adsimple-321190275">Cloudflare Datenschutzerklärung</h2>
      <p class="text-dark">Wir verwenden auf dieser Webseite Cloudflare der Firma Cloudflare, Inc. (101
        Townsend St., San Francisco, CA 94107, USA), um unsere Webseite schneller und sicherer zu machen.
        Dabei verwendet Cloudflare Cookies und verarbeitet User-Daten. Cloudflare, Inc. ist eine
        amerikanische Firma, die ein Content Delivery Network und diverse Sicherheitsdienste bereitstellt.
        Diese Dienste befinden sich zwischen dem User und unserem Hosting-Anbieter und fungieren als <a
            class="adsimple-321190275" href="https://de.wikipedia.org/wiki/Reverse_Proxy"
            target="_blank" rel="noopener">Reverse Proxy</a>für Webseiten. Was das alles genau bedeutet,
        versuchen wir im Folgenden genauer zu erläutern.</p>
      <h3 class="adsimple-321190275">Was ist Cloudflare?</h3>
      <p class="text-dark">Ein Content Delivery Network (CDN), wie es die Firma Cloudflare bereitstellt, ist
        nichts anderes als ein Netzwerk aus über das Internet verbundenen Servern. Cloudflare hat auf der
        ganzen Welt solche Server verteilt, um Webseiten schneller auf Ihren Bildschirm zu bringen. Ganz
        einfach gesagt, legt Cloudflare Kopien unserer Website an und platziert sie auf ihren eigenen
        Servern. Wenn Sie jetzt unsere Webseite besuchen, stellt ein System der Lastenverteilung sicher,
        dass die größten Teile unserer Webseite von jenem Server ausgeliefert werden, der Ihnen unsere
        Webseite am schnellsten anzeigen kann. Die Strecke der Datenübertragung zu Ihrem Browser wird durch
        ein CDN deutlich verkürzt. Somit wird Ihnen der Content unserer Webseite durch Cloudflare nicht nur
        von unserem Hosting-Server geliefert, sondern von Servern aus der ganzen Welt. Besonders hilfreich
        wird der Einsatz von Cloudflare für User aus dem Ausland, da hier die Seite von einem Server in der
        Nähe ausgeliefert werden kann. Neben dem schnellen Ausliefern von Webseiten bietet Cloudflare auch
        diverse Sicherheitsdienste, wie den DDoS-Schutz oder die Web Application Firewall an.</p>
      <h3 class="adsimple-321190275">Warum wir Cloudflare auf unserer Website verwenden?</h3>
      <p class="text-dark">Natürlich wollen wir Ihnen mit unserer Webseite das bestmögliche Service bieten.
        Cloudflare hilft uns dabei, unsere Webseite schneller und sicherer zu machen. Cloudflare bietet uns
        sowohl Web-Optimierungen als auch Sicherheitsdienste, wie DDoS-Schutz und Web-Firewall, an. Dazu
        gehören auch ein <a class="adsimple-321190275" href="https://de.wikipedia.org/wiki/Reverse_Proxy"
                            target="_blank" rel="noopener">Reverse-Proxy</a> und das
        Content-Verteilungsnetzwerk (CDN). Cloudflare blockiert Bedrohungen und begrenzt missbräuchliche
        Bots und Crawler, die unsere Bandbreite und Serverressourcen verschwenden. Durch das Speichern
        unserer Webseite auf lokalen Datenzentren und das Blockieren von Spam-Software ermöglicht
        Cloudflare, unsere Bandbreitnutzung etwa um 60% zu reduzieren. Das Bereitstellen von Inhalten über
        ein Datenzentrum in Ihrer Nähe und einiger dort durchgeführten Web-Optimierungen reduziert die
        durchschnittliche Ladezeit einer Website etwa um die Hälfte. Durch die Einstellung „I´m Under Attack
        Mode“ („Ich werde angegriffen“-Modus) können laut Cloudflare weitere Angriffe abgeschwächt werden,
        indem eine JavaScript-Rechenaufgabe angezeigt wird, die man lösen muss, bevor ein User auf eine
        Webseite zugreifen kann. Insgesamt wird dadurch unsere Website deutlich leistungsstärker und weniger
        anfällig auf Spam oder andere Angriffe.</p>
      <h3 class="adsimple-321190275">Welche Daten werden von Cloudflare gespeichert?</h3>
      <p class="text-dark">Cloudflare leitet im Allgemeinen nur jene Daten weiter, die von Websitebetreibern
        gesteuert werden. Die Inhalte werden also nicht von Cloudflare bestimmt, sondern immer vom
        Websitebetreiber selbst. Zudem erfasst Cloudflare unter Umständen bestimmte Informationen zur
        Nutzung unserer Webseite und verarbeitet Daten, die von uns versendet werden oder für die Cloudflare
        entsprechende Anweisungen erhalten hat. In den meisten Fällen erhält Cloudflare Daten wie
        Kontaktinformationen, IP-Adressen, Sicherheitsfingerabdrücke, DNS-Protokolldaten und Leistungsdaten
        für Webseiten, die aus der Browseraktivitäten abgeleitet werden. Protokolldaten helfen Cloudflare
        beispielsweise dabei, neue Bedrohungen zu erkennen. So kann Cloudflare einen hohen Sicherheitsschutz
        für unsere Webseite gewährleisten. Cloudflare verarbeitet diese Daten im Rahmen der Services unter
        Einhaltung der geltenden Gesetze. Dazu zählt natürlich auch die Datenschutzgrundverordnung
        (DSGVO).</p>
      <p class="text-dark">Aus Sicherheitsgründen verwendet Cloudflare auch ein Cookie. Das Cookie (__cfduid)
        wird verwendet, um einzelne User hinter einer gemeinsam genutzten IP-Adresse zu identifizieren und
        Sicherheitseinstellungen für jeden einzelnen User anzuwenden. Sehr nützlich wird dieses Cookie
        beispielweise, wenn Sie unsere Webseite aus einem Lokal benutzen, in dem sich eine Reihe infizierter
        Computer befinden. Wenn aber Ihr Computer vertrauenswürdig ist, können wir dies anhand des Cookies
        erkennen. So können Sie, trotz infizierter PCs im Umfeld, ungehindert durch unsere Webseite surfen.
        Wichtig zu wissen ist auch noch, dass dieses Cookie keine personenbezogenen Daten speichert. Dieses
        Cookie ist für die Cloudflare-Sicherheitsfunktionen unbedingt erforderlich und kann nicht
        deaktiviert werden.</p>
      <h3 class="adsimple-321190275">Cookies von Cloudflare</h3>
      <ul class="adsimple-321190275">
        <li class="adsimple-321190275">__cfduid
          <ul class="adsimple-321190275">
            <li class="adsimple-321190275">Ablaufzeit: 1 Jahr</li>
            <li class="adsimple-321190275">Verwendung: Sicherheitseinstellungen für jeden einzelnen
              Besucher
            </li>
            <li class="adsimple-321190275">Beispielhafter Wert:
              d798bf7df9c1ad5b7583eda5cc5e78321190275
            </li>
          </ul>
        </li>
      </ul>
      <p class="text-dark">Cloudflare arbeitet auch mit Drittanbietern zusammen. Diese dürfen personenbezogene
        Daten nur unter Anweisung der Firma Cloudflare und in Übereinstimmung mit den Datenschutzrichtlinien
        und anderer Vertraulichkeits- und Sicherheitsmaßnahmen verarbeiten. Ohne explizite Einwilligung von
        uns gibt Cloudflare keine personenbezogenen Daten weiter.</p>
      <h3 class="adsimple-321190275">Wie lange und wo werden die Daten gespeichert?</h3>
      <p class="text-dark">Cloudflare speichert Ihre Informationen hauptsächlich in den USA und im
        Europäischen Wirtschaftsraum. Cloudflare kann die oben beschriebenen Informationen aus der ganzen
        Welt übertragen und darauf zugreifen. Im Allgemeinen speichert Cloudflare Daten auf User-Ebene für
        Domains in den Versionen Free, Pro und Business für weniger als 24 Stunden. Für Enterprise Domains,
        die Cloudflare Logs (früher Enterprise LogShare oder ELS) aktiviert haben, können die Daten bis zu 7
        Tage gespeichert werden. Wenn allerdings IP-Adressen bei Cloudflare Sicherheitswarnungen auslösen,
        kann es zu Ausnahmen der oben angeführten Speicherungsdauer kommen.</p>
      <h3 class="adsimple-321190275">Wie kann ich meine Daten löschen bzw. die Datenspeicherung
        verhindern?</h3>
      <p class="text-dark">Cloudflare bewahrt Daten-Protokolle nur solange wie nötig auf und diese Daten
        werden auch in den meisten Fällen innerhalb von 24 Stunden wieder gelöscht. Cloudflare speichert
        auch keine personenbezogenen Daten, wie beispielsweise Ihre IP-Adresse. Es gibt allerdings
        Informationen, die Cloudflare als Teil seiner permanenten Protokolle auf unbestimmte Zeit speichert,
        um so die Gesamtleistung von Cloudflare Resolver zu verbessern und etwaige Sicherheitsrisiken zu
        erkennen. Welche permanenten Protokolle genau speichert werden, können Sie auf <a
            class="adsimple-321190275" href="https://www.cloudflare.com/application/privacypolicy/"
            target="_blank" rel="noopener">https://www.cloudflare.com/application/privacypolicy/</a>
        nachlesen. Alle Daten, die Cloudflare sammelt (temporär oder permanent), werden von allen
        personenbezogenen Daten bereinigt. Alle permanenten Protokolle werden zudem von Cloudflare
        anonymisiert.</p>
      <p class="text-dark">Cloudflare geht in ihrer Datenschutzerklärung darauf ein, dass sie für die Inhalte,
        die sie erhalten nicht verantwortlich sind. Wenn Sie beispielsweise bei Cloudflare anfragen, ob sie
        Ihre Inhalte aktualisieren oder löschen können, verweist Cloudflare grundsätzlich auf uns als
        Websitebetreiber. Sie können auch die gesamte Erfassung und Verarbeitung Ihrer Daten durch
        Cloudflare komplett unterbinden, indem Sie die Ausführung von Script-Code in Ihrem Browser
        deaktivieren oder einen Script-Blocker in Ihren Browser einbinden.</p>
      <p class="text-dark">Cloudflare ist aktiver Teilnehmer beim EU-U.S. Privacy Shield Framework wodurch der
        korrekte und sichere Datentransfer persönlicher Daten geregelt wird. Mehr Informationen dazu finden
        Sie auf <a class="adsimple-321190275"
                   href="https://www.privacyshield.gov/participant?id=a2zt0000000GnZKAA0&amp;tid=321190275"
                   target="_blank" rel="noopener">https://www.privacyshield.gov/participant?id=a2zt0000000GnZKAA0</a>.<br/>
        Mehr Informationen zum Datenschutz bei Cloudflare finden Sie auf <a class="adsimple-321190275"
                                                                            href="https://www.cloudflare.com/de-de/privacypolicy/?tid=321190275"
                                                                            target="_blank" rel="noopener">https://www.cloudflare.com/de-de/privacypolicy/</a>
      </p>
      <p class="text-dark" style="margin-top:15px;">Quelle: Erstellt mit dem <a
          title="Datenschutz Generator Deutschland" href="https://www.adsimple.de/datenschutz-generator/"
          target="_blank" rel="follow" style="text-decoration:none;">Datenschutz Generator</a> von
        AdSimple in Kooperation mit <a href="https://www.hashtagmann.de" target="_blank" rel="follow"
                                       title="">hashtagmann.de</a>
      </p>
    </b-modal>


  </div>
  <div class="container imprint-text">

    <br class="no-move"/>
    <br class="no-move"/>

    <h3 class="text-dark">EU-Streitschlichtung</h3>
    <p class="text-dark">Die Europ&auml;ische Kommission stellt eine Plattform zur Online-Streitbeilegung
      (OS) bereit: <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">https://ec.europa.eu/consumers/odr</a>.
      Unsere E-Mail-Adresse finden Sie oben im Impressum.</p>

    <h3 class="text-dark">Verbraucherstreitbeilegung</h3>
    <p class="text-dark">Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
      Verbraucherschlichtungsstelle teilzunehmen.</p>

    <h3 class="text-dark">Haftung f&uuml;r Inhalte</h3>
    <p class="text-dark">Als Diensteanbieter sind wir gem&auml;&szlig; &sect; 7 Abs.1 TMG f&uuml;r eigene
      Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach &sect;&sect; 8 bis 10
      TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, &uuml;bermittelte oder gespeicherte
      fremde Informationen zu &uuml;berwachen oder nach Umst&auml;nden zu forschen, die auf eine
      rechtswidrige T&auml;tigkeit hinweisen.</p>
    <p class="text-dark">Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den
      allgemeinen Gesetzen bleiben hiervon unber&uuml;hrt. Eine diesbez&uuml;gliche Haftung ist jedoch
      erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung m&ouml;glich. Bei Bekanntwerden
      von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.</p>
    <h3>Haftung f&uuml;r Links</h3>
    <p class="text-dark">Unser Angebot enth&auml;lt Links zu externen Websites Dritter, auf deren Inhalte
      wir keinen Einfluss haben. Deshalb k&ouml;nnen wir f&uuml;r diese fremden Inhalte auch keine Gew&auml;hr
      &uuml;bernehmen. F&uuml;r die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder
      Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf m&ouml;gliche
      Rechtsverst&ouml;&szlig;e &uuml;berpr&uuml;ft. Rechtswidrige Inhalte waren zum Zeitpunkt der
      Verlinkung nicht erkennbar.</p>
    <p class="text-dark">Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne
      konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von
      Rechtsverletzungen werden wir derartige Links umgehend entfernen.</p>
    <h3>Urheberrecht</h3>
    <p class="text-dark">Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten
      unterliegen dem deutschen Urheberrecht. Die Vervielf&auml;ltigung, Bearbeitung, Verbreitung und jede
      Art der Verwertung au&szlig;erhalb der Grenzen des Urheberrechtes bed&uuml;rfen der schriftlichen
      Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur f&uuml;r
      den privaten, nicht kommerziellen Gebrauch gestattet.</p>
    <p class="text-dark">Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die
      Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet.
      Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen
      entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte
      umgehend entfernen.</p>

    <p class="text-dark">Quelle: <a href="https://www.e-recht24.de/impressum-generator.html">https://www.e-recht24.de/impressum-generator.html</a>
    </p>
  </div>

  <br class="no-move"/>
  <br class="no-move"/>
  <br class="no-move"/>

  <div class="" style="alignment: bottom">

    <div class="" style="alignment: bottom">
      <p class="smaller-end-text">© {{today.getFullYear()}}
        <a style="color: #6868b3" href="https://labyhelp.de">LabyHelp Group</a> -
        <a style="color: #6868b3"
           href="https://labyhelp.de/support">Support</a>
        -
        <a style="color: #6868b3"
           href="https://labyhelp.de/apply">Apply</a>
        -
        <a style="color: #6868b3"
           href="https://labyhelp.de/creator">Creator</a>
        -
        <a style="color: #6868b3"
           href="ts3server://labyhelp.de">TeamSpeak</a>
      </p>
    </div>

  </div>

</div>
</div>
</template>

<script>
export default {
  name: "Privacy",
  data() {
    return {
      today: new Date()
    }
  },
}
</script>

<style scoped>

</style>